import { render, staticRenderFns } from "./stylelist_for_qc.vue?vue&type=template&id=0bd7a6b9"
import script from "./stylelist_for_qc.vue?vue&type=script&lang=js"
export * from "./stylelist_for_qc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports